import { useCallback, useEffect, useState } from "react";
import { IUser } from "../interfaces/user.interface";
import { isUserFreeTrialEnded } from "../utils/helpers";

type UseUserResult = {
    isFreeTrialEnded: boolean;
    loading: boolean;
    error: string | null;
    refresh: () => Promise<void>;
};

const useUser = (user?: IUser | null): UseUserResult => {
    const [isFreeTrialEndedState, setIsFreeTrialEnded] =
        useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const evaluate = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const ended = await isUserFreeTrialEnded(user);
            setIsFreeTrialEnded(ended);
        } catch (err: any) {
            setError(err?.message ?? String(err));
            setIsFreeTrialEnded(true);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        // evaluate on mount and whenever user changes
        void evaluate();
    }, [evaluate]);

    return {
        isFreeTrialEnded: isFreeTrialEndedState,
        loading,
        error,
        refresh: evaluate,
    };
};

export default useUser;
